import { TRootState } from "store";
import { IUserManagementState } from "./userManagement.types";

export const getUserManagementSelector = (state: TRootState): IUserManagementState => state.userManagement;
